import type { FaireProductEntity } from "../../entity_types/product";

export const p_f9jtxegv6y: FaireProductEntity = {
  token: "p_f9jtxegv6y",
  type: "product",
  name: "Calypso Lemonades, 16oz",
  brandToken: "b_47s98587ya",
  brandName: "Oasis Snacks",
  imageUrl:
    "https://cdn.faire.com/fastly/a1bf91a069c53f501f72280cea6cff479ca4ed6492b19f7a4d3c1e15fe9658d1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a36dad9a3abafa28c0eed11f09f852db8995185f218d176d24481da73d03986.jpeg",
    "https://cdn.faire.com/fastly/5790cf21e2e3c9b32c3195c6df39aff9a83e8b2e0c6e865b999a40583e45ddaa.jpeg",
    "https://cdn.faire.com/fastly/d8df6b30411971638e24ceed1077fe29a13d9a047a6dffa950ca8468b712097c.jpeg",
    "https://cdn.faire.com/fastly/34f06ec165e92b137b2b946c9849a75a76fbb0b6c547e70f37569c5387cc3a30.jpeg",
    "https://cdn.faire.com/fastly/58d345142110739b341766733a72a74a6190a2faa40e2655ee3e50b5e0ed3eda.jpeg",
    "https://cdn.faire.com/fastly/d1adf1a5c9e03c2e792b34c27cad443e9f86beb41841416161669ccbbfd89fab.jpeg",
    "https://cdn.faire.com/fastly/0664fb8afc5c24be7d346e5b7ecdec54cf64edd273dfb45c798032cd204d3ca6.jpeg",
    "https://cdn.faire.com/fastly/5fa23fcfc47e66ee7b6ec39c882b9488d7c28b7632579a693053b4eaf8a128af.jpeg",
    "https://cdn.faire.com/fastly/0a77679ab8cce574f195641f22bcf07d964793bfe41ed2c80a0831bf10c286df.jpeg",
    "https://cdn.faire.com/fastly/f888120c19481c8c255c6093addb6d236f1baed4b7c39e6aafc1f4a7b542ee30.jpeg",
    "https://cdn.faire.com/fastly/ff11573108299db2123bb91f0b3f378160dd22c251754856cdc39784a67c5eea.jpeg",
    "https://cdn.faire.com/fastly/802218bd9db6134372a91efacebea5f289b3656e0993a3a1bcf43e8da9c9861c.jpeg",
    "https://cdn.faire.com/fastly/2bda1bc10cd98d92b92a9d019631a590516706ed6722bf459f790bbb86f22d5e.jpeg",
    "https://cdn.faire.com/fastly/62dfd53659cbba52046c5074460d43a8e7f17257a8abf7701cc67d5b77b43313.jpeg",
    "https://cdn.faire.com/fastly/f536ea037533ec42669ced1e02f0c072e9cb658f030c52a4f6ee79dafe8a07cf.jpeg",
    "https://cdn.faire.com/fastly/f1c5d813a78e51e51fa7db47acdee0b0b67ec83868f459ef5a542c90ea7aa252.jpeg",
    "https://cdn.faire.com/fastly/ca0f75c8913f215d0ad493bd91397597238ff14f415ada5c92319f800007e440.jpeg",
    "https://cdn.faire.com/fastly/6004937f35d17b6a75c704d74d86b880814665d8013c6e8233ff34cbc4875d02.jpeg",
    "https://cdn.faire.com/fastly/91ab404fe54289834f69ecf18bc3d7d9565dfc4ff1b98a1d36ebabb81dcb86af.png",
  ],
  priceDollars: 3.02,
  description:
    "Calypso, the originator of the flavored lemonade category, has evolved from four lemonade blends into over a dozen lemonade, limeade, and tea and lemonade combinations over the past eighteen years. Each Calypso is made with real lemon or lime bits, real sugar, natural flavors and served in premium custom glass bottles.",
  tags: [],
  msrpDollars: 6.04,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:32.619Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
